import React from 'react';
import ClassAssembly5E  from 'views/ClassAssembly5E';

const ClassAssembly5EPage = () => {
    return <ClassAssembly5E />;
  };
  
  export default ClassAssembly5EPage;

  //5E